module.exports = __webpack_public_path__ + "img/b2.2cee96b7.png";